<template>
  <div id="richTextSection" class="main-area">
    <PageTop class="title" title="Ürün Açıklaması" />
    <div id="my-toolbar" class="ql-toolbar ql-snow">
      <div>
        <span class="ql-formats">
          <select class="ql-size">
            <option value="small"></option>
            <option selected></option>
            <option value="large"></option>
            <option value="huge"></option>
          </select>
          <select class="ql-color"></select>
          <select class="ql-background"></select>
          <select class="ql-align"></select>  
        </span>

        <span class="ql-formats">
          <button class="ql-bold"></button>
          <button class="ql-italic"></button>
          <button class="ql-underline"></button>
          <button class="ql-strike"></button>
        </span>

        <span class="ql-formats">
          <select class="ql-header">
            <option selected></option>
            <option value="1"></option>
            <option value="2"></option>
          </select>
        </span>

        <span class="ql-formats">
          <button class="ql-list" value="ordered"></button>
          <button class="ql-list" value="bullet"></button>
        </span>

        <span class="ql-formats">
          <button class="ql-blockquote"></button>
          <button class="ql-code-block"></button>
        </span>

        <span class="ql-formats">
          <button class="ql-link"></button>
        </span>

        <span class="ql-formats">
          <button class="ql-clean"></button>
        </span>
      </div>

      <span class="ql-formats">
        <div id="ql-custom">
          <AppButton v-if="props.isHasContent" sm secondary title="Açıklama Şablonu Seç" @click="handleClick()"  />
        </div>
      </span>
    </div>
    <QuillEditor
      theme="snow"
      v-model:content="internalContent"
      contentType="html"
      placeholder="Ürünün satışını artırmak için ürün özelliklerini madde madde açıklayabilir, avantajlarını vurgulayabilirsiniz."
    />
    <span v-if="!isDescriptionAreaValid" class="errorText">Açıklama alanı boş olamaz.</span>
    <div class="form-group">
      <div class="checkbox-label">
        <Checkbox
          label="Bu açıklamayı daha sonra tekrar kullanmak için şablon olarak kaydet."
          id="select"
          :checked="isReusablePattern"
          :onClickFn="handleCheckBoxClick"
        />
      </div>

      <div v-if="isReusablePattern" class="input-field">
        <Input
          type="text"
          class="custom-input"
          id="template-name"
          v-model:value="templateName"
          placeholder="Şablon Adı Gir"
          :isError="isError"
        />
        <span v-if="isError" class="errorText">Şablon adı boş bırakılamaz.</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import PageTop from "@/components/Page/PageTop.vue";
import { QuillEditor, Checkbox, AppButton, Input } from "@n11/so-ui-components";
import { ref, watch } from "vue";

const emit = defineEmits(['open-modal','update:content','update:isReusablePattern','update:templateName']);

const props = defineProps({
  content: {
    type: String,
    required: false
  },
  isHasContent: {
    type: Boolean,
    default: false
  }
});

const isError = ref(false);
const isReusablePattern = ref(false);
const internalContent = ref(props.content || null);
const templateName = ref("");
const isDescriptionAreaValid = ref(true);
const isReusablePatternValid = ref(false);

watch(() => props.content, (newVal) => {
  internalContent.value = newVal;
});

watch(internalContent, (val) => {
  const isEmpty = val?.trim() === "" || val === "<p><br></p>";
  const finalVal = isEmpty ? null : val;
  isDescriptionAreaValid.value = !isEmpty;

  emit('update:content', finalVal);
});

watch(templateName, (val) => {
  emit("update:templateName", val);
  
  if (val.trim() !== "") {
    isError.value = false;
  }
});

const handleClick = () => {
  emit('open-modal');
}

const handleCheckBoxClick = () => {
  isReusablePattern.value = !isReusablePattern.value;
  emit('update:isReusablePattern', isReusablePattern.value);
}

const getRichText = () => {
  const cleaned = (internalContent.value || "").replace(/<[^>]*>/g, '').trim();
  isDescriptionAreaValid.value = cleaned !== '';
  isReusablePatternValid.value = isReusablePattern.value ? templateName.value.trim() !== "" : true;
  const validTemplate = isDescriptionAreaValid.value && isReusablePatternValid.value;
  isError.value = !isReusablePatternValid.value;

  return {
    data: {
      templateName: validTemplate ? templateName.value : null,
    },
    isValid: validTemplate,
  };
};

defineExpose({
  getRichText
})
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";
@import "@/assets/styles/utilities.scss";

.main-area {
  width: 100%;
  display: flex;
  padding: 24px;
  border: 1px solid #d3d6df;
  border-radius: 8px;
  height: auto;
  max-height: 468px;
}
.title {
  margin-bottom: 16px;
}
.form-group {
  display: flex;
  align-items: center;
  gap: 24px;
  margin-top: 16px;

  .checkbox-label {
    display: flex;
    align-items: center;
    white-space: nowrap;
  }

  .input-field {
    flex: 0 0 306px;
    display: flex;
    flex-direction: column;
  }
  .custom-input {
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
  }

  label {
    font-size: 14px;
    color: #333;
  }

  input[type="checkbox"] {
    margin-right: 8px;
  }
}

#ql-custom {
  button {
    width: 100%;
  }
}

.ql-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;

  &.ql-snow {
    background-color:  $colorD10;
    border-radius: 6px 6px 0px 0px;
  }

  .ql-container {
    overflow-y: auto;
  }

  > div {
    width: 100%;
  }
}

.ql-toolbar.ql-snow + div {
  display: none;
}

.errorText {
  font-size: 11px;
  color: $colorE50;
  padding: 0 12px;
  margin-top: 4px;
} 

</style>
